webpackJsonp([181],{

/***/ 1174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "为什么作者直接删除了我在 issue 下的评论 | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 1989:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1174),
  /* template */
  __webpack_require__(2278),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/why-delete-my-issue-comment-24.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] why-delete-my-issue-comment-24.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5e10a420", Component.options)
  } else {
    hotAPI.reload("data-v-5e10a420", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2278:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("为什么作者直接删除了我在 issue 下的评论")]), _vm._v(" "), _c('div', {
    staticClass: "warning"
  }, [_c('p', [_vm._v("被删除评论一般是因为：你在 issue 下写了一条和当前 issue 没有关系的评论，或者提了和 issue 无关的问题。")])]), _vm._v(" "), _c('p', [_vm._v("即使是关于同一个组件，和当前 issue 讨论主题无关的评论也会造成管理麻烦，影响讨论。")]), _vm._v(" "), _c('p', [_vm._v("作为维护者我们想让每条 issue 讨论主题集中，以便管理追踪。")]), _vm._v(" "), _c('p', [_vm._v("作为 issue 创建者同样如此，试想你愿意别人在你的网站发无关内容或者垃圾吗？")]), _vm._v(" "), _c('p', [_vm._v("尊重他人，理解作为维护者管理每条 issue 所花费的时间精力再提问可以得到更好和更快的帮助。")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5e10a420", module.exports)
  }
}

/***/ }),

/***/ 600:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1989);

/***/ })

});


// WEBPACK FOOTER //
// 181.57faf5ef.js